module.exports = __webpack_public_path__ + "img/banner3.2461cadc.jpg";